module.exports = "/_next/static/images/top-d9ebd2aa210995eff9b326914e745efc.jpg";